export const version: "published" | "draft" = "published";

export type ComicOption = {
  name: string;
  locked: boolean;
  //   option_id: string;
};
export type ComicSection = {
  _uid: string;
  // section_id: string;
  title: string;
  options: ComicOption[];
  imgs: { filename: string; id: string }[];
  release_date: string;
  vote_deadline: string;
  next_comic_time: string;
  prev: string;
  next: string;
  questionText: string;
  questionInstructionText: string;
  questionInstructionSubText: string;
};

export interface ComicSectionData {
  slug: string;
  content: ComicSection;
}
export type ComicEvent = {
  title: string;
  comicFooterTitle: string;
  waitForDataText: string;
  waitForVoteText: string;
  loadingText: string;
  computingPowerText: string;
  voteSubmitText: string;
  voteCancelText: string;
  voteTextPrefixText: string;
  voteTitleText: string;
  voteTitleSubText: string;
  nextSectionText: string;
  previousSectionText: string;
  currentVoteText: string;
  youVotedText: string;
  loginAndVoteText: string;
  meta: any;
};
export type ComicSummary = Record<string, number>;

//TODO: 正是改成Date.now
// const now = Date.now();

//測試用
const anchorNow = Date.now();
// const anchorNow = new Date("2022-03-18T14:00:00+08:00").getTime();
const now = new Date().getTime(); //
export const fakeNow = () => {
  const offset = anchorNow - now;
  return Date.now() + offset;
  // return anchorNow;
};
